import { render } from "./ImgLOGO.vue?vue&type=template&id=a9ee93f6&scoped=true"
import script from "./ImgLOGO.vue?vue&type=script&lang=js"
export * from "./ImgLOGO.vue?vue&type=script&lang=js"

import "./ImgLOGO.vue?vue&type=style&index=0&id=a9ee93f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ee93f6"]])

export default __exports__